$(function () {
fn_layout_header();
fn_layout_main();
fn_part_slider();
fn_part_ui_cookies();
fn_part_ui_input();
fn_part_ui_number();
fn_part_ui_option();
fn_part_ui_select();
fn_part_ui_wsw();
fn_comp_contacts();
fn_comp_homepage();
fn_comp_models_detail();
fn_comp_service();
fn_comp_testdrive();
fn_comp_visual();
});